// extracted by mini-css-extract-plugin
module.exports = {"vUiHueLight":"#eee","folder":"FolderPickerItem__folder___msZg3","disabled":"FolderPickerItem__disabled___3XJ64"};